/* eslint-disable */
import React, { Component } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import ReactTooltip from 'react-tooltip';

import Aux from '../../hoc/Aux'
import Classes from './RegisterScreen.css'
import Map from './Map';
import config   from './../../moramma-config.json';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import axios from 'axios';
import lang from './../../lang.json';

import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { maxWidth } from '@material-ui/system';


class RegisterScreen extends Component {   
    state = {
        txtName: '',
        txtSurname: '',
        txtEmail: '',
        txtEmailConfirm: '',
        txtEmailError: false,
        txtEmailFormatError: false,
        txtImageError: false,
        txtNameError: false,
        txtSurnameError: false,
        txtLocationSloganErr: false,
        txtLat: '',
        txtLng: '',
        txtaddress: '',
        txtLocationName:'',
        txtLocationSlogan:'',
        txtLocationNameError: false,
        isRegister: false,
        errorField: 'error',
        chbxPersonalInfo: false,
        chbxLocationInfo: false,
        urlImg : '',
        next: false,
        language: 'IT-it',
        mylat:'',
        mylng:'',
        selectArea: 50,
        selectFloorNumber: 0,
        selectSpotRadius: 'Altro',
        isUsingOauth: false,
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        const name = query.get('name');
        const surname = query.get('surname');
        const email = query.get('email');

        if(name) {
            this.setState({ isUsingOauth: true });
        }

      //  console.log(name, surname, email);

        this.setState({ txtName: name , txtEmailConfirm: email, txtEmail: email, txtSurname: surname });

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.displayLocationInfo);
          }
    }

   displayLocationInfo = (position) => {
        const lng = position.coords.longitude;
        const lat = position.coords.latitude;
      
        console.log(`longitude: ${ lng } | latitude: ${ lat }`);
        this.setState({mylat:lat, mylng:lng});

   }
   
    onChangeTxtName = (event) => {
        const regex = new RegExp(/^[a-zA-Z0-9_ ]{3,20}$/i);
        if(regex.test(event.target.value)) {
            this.setState({txtName: event.target.value, txtNameError : false});
        }else{
            this.setState({txtName: event.target.value, txtNameError : true});
        }
    }

    onChangeTxtLocationName = (event) => {
        const regex = new RegExp(/^[a-zA-Z0-9_ ]{3,25}$/i);
        let s = event.target.value;
        if (regex.test(s)) {
            this.setState({txtLocationName: s, txtLocationNameError: false});
        }
        else {
            this.setState({txtLocationName: s, txtLocationNameError: true});
        }

    }

    onChangeTxtLocationSlogan = (event) => {
        const regex = new RegExp(/^[a-zA-Z0-9_ ]{3,80}/i);
        if(regex.test(event.target.value)) {
            this.setState({txtLocationSlogan: event.target.value, txtLocationSloganErr: false});
        }else{
            this.setState({txtLocationSlogan: event.target.value, txtLocationSloganErr: true});
        }
    }

    onChangeTxtSurname = (event) => {
        const regex = new RegExp(/^[a-zA-Z0-9_ ]{3,25}$/i);
        if(regex.test(event.target.value)) {
            this.setState({txtSurname: event.target.value, txtSurnameError : false});
        }else{
            this.setState({txtSurname: event.target.value, txtSurnameError : true});
        }
    }

    onChangeTxtEmail= (event) => {
        const txt = event.target.value;
        const RE_MAIL = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i);
        if(RE_MAIL.test(txt)) {
            // send link calling server API
            this.setState({txtEmail: txt, txtEmailFormatError: false});
        }
        else {
            this.setState({txtEmailFormatError : true});
        }

        this.setState({txtEmail: txt});
    }

    onEmailPasteEvent = (event) => {
    }

    onChangeTxtEmailConfirm = (event) => {
        this.setState({txtEmailConfirm: event.target.value});
        if(this.state.txtEmail === event.target.value) {
            this.setState({txtEmailError : false})
        }else {
            this.setState({txtEmailError : true})
        }
    }

    onChangeChbxPersonalInfo = (event) => {
        let tmp = this.state.chbxPersonalInfo
        this.setState({chbxPersonalInfo: !tmp})
    }

    onChangeChbxPlaceInfo = (event) => {
        let tmp = this.state.chbxLocationInfo
        this.setState({chbxLocationInfo: !tmp})
    }

    onChangeUrlImg = (event) => {
        const txt = event.target.value;
        const RE_MAIL = new RegExp(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png|jpeg)/i);
        if(RE_MAIL.test(txt)) {
            // send link calling server API
            this.setState({urlImg: event.target.value, txtImageError: false});
        }
        else {
            this.setState({txtImageError : true});
        }  
    }

    link = (latlng, street, lat, lng) => {
        this.setState({txtlatlong: latlng, txtaddress: street, txtLat: lat, txtLng:lng});
    }

    registerBtn = (event) => {
        if(this.state.txtLocationNameError) {
            ToastsStore.error('Please fill the Spot name');
            return;
        }
        if(this.state.txtLocationSloganErr) {
            ToastsStore.error('Please fill the slogan');
            return;
        }
        if(!this.state.urlImg) {
            ToastsStore.error('Please fill the url image');
            return;
        }
        if(!this.state.chbxLocationInfo) {
            ToastsStore.error('You need to agree local privacy policy.');
            return;
        }
        if(this.state.txtImageError) {
            ToastsStore.error('You need to insert a valid url image.');
            return;
        }
 
        axios({
            method: 'post',
            url: `${config['BASE_API']}/auth/reactuser`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            data: { 
                name: this.state.txtName,
                surname: this.state.txtSurname,
                email: this.state.txtEmail,
                lat: this.state.txtLat,
                lng: this.state.txtLng,
                address: this.state.txtaddress,
                locationName: this.state.txtLocationName,
                locationSlogan: this.state.txtLocationSlogan,
                spotSize: this.state.selectArea,
                spotActiveRadius: this.state.selectSpotRadius,
                spotFloor: this.state.selectFloorNumber,
                barimg: this.state.urlImg }
        })
        .then( (data) => {
            console.warn(data);
            if(data.data.code === 200) {
                document.body.style.overflow = "auto";
                this.setState({isRegister:true});
            }
            else if(data.data.code === 500) {
                ToastsStore.success('Already registered!'+data.data.message);
            }
            else {
                ToastsStore.error('Ooops, an error occurred. Did you fill all fields?');
            }
        });
    }

    nextButton = () => {
        if(!this.state.chbxPersonalInfo) {
            ToastsStore.error('You need to agree user privacy policy');
            return;
        }
        if(this.state.txtEmailFormatError) {
            ToastsStore.error('Please make sure email confirm is correct');
            return;
        }
        if(this.state.txtEmailError) {
            ToastsStore.error('Please fill email field');
            return;
        }
        if(this.state.txtNameError) {
            ToastsStore.error('Please fill name field');
            return;
        }
        if(this.state.txtSurnameError) {
            ToastsStore.error('Please fill surname field');
            return;
        }

        this.setState({ next: true });
    }

    changeLanguage = () => {
        if(this.state.language === 'IT-it') {
          this.setState({ language: 'EN-en' });
        } else {
          this.setState({ language: 'IT-it' });
        }
    }


    onAreaSelectChanges = (e) => {
        this.setState({ selectArea: e.target.value });
    }

    onFloorNumberChanges= (e) => {
        this.setState({ selectFloorNumber: e.target.value });
    }

    onSpotRadiusChanges= (e) => {
        this.setState({ selectSpotRadius: e.target.value });
    }

    render() {

        if (this.state.next){
            document.body.style.overflow = "auto";
        }

        if(this.state.isRegister === true && this.state.isUsingOauth === true) {
            return (
                <Aux>
                    <div className="container-fluid">
                        <br />
                        <br />
                        <div className="row">
                        <div className="col" />
                        <div className={`col-6 ${Classes.TxtCenter}`}>
                            <div className={` ${Classes.CardLogin}`}>
                                <br />
                              
                                <br />
                                <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                                <br />
                                <br />
                                <h5>La registrazione e' andata a buon fine!</h5>

                                <br/>  
                                <div className={Classes.BlueInfo}>
                                <p>Dato che hai eseguito la registrazione tramite l'autenticazione veloce di Google o Facebook, puoi fare il login senza dover confermare l'account</p>
                                <button className={Classes.CustomLoginButton} type="button"> <a href="/" target="_blank"> <i className="fas fa-sign-in-alt"> </i> Login</a></button>
                               
                                </div>

                                <br />
                                <div className={Classes.BlueInfo}>
                                <p><b>I prossimi passi?</b> <br /> - Esegui il login per impostare e configurare il tuo spot! <br/> - Scarica l'app moramma dagli store per interagire con il tuo spot</p>
                                <p>
                                    <span>
                                        <a style={{textDecoration:'none', color:'white', fontSize:'45px'}} href="https://play.google.com/store/apps/details?id=wagooitalia.wagoomusic&hl=it"><i  style={{color:'white !important'}} class="fa-icons fab fa-android animated fadeIn"></i>
                                        </a> <a style={{textDecoration:'none', color:'white', fontSize:'45px'}} href="https://itunes.apple.com/it/app/moramma/id1382717294?mt=8"><i class="fa-icons fab fa-apple animated fadeIn"></i></a></span></p>
                                     </div>
                            </div>
                            <br/>
                        </div>
                        <div className="col" />
                        </div>
                    </div>
                    <ReactTooltip />
                    <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
                </Aux>
            )
        }
        if(this.state.isRegister === true && this.state.isUsingOauth === false) {
            return (
                <Aux>
                    <div className="container-fluid">
                        <br />
                        <br />
                        <div className="row">
                        <div className="col" />
                        <div className={`col-6 ${Classes.TxtCenter}`}>
                            <div className={` ${Classes.CardLogin}`}>
                                <br />
                              
                                <br />
                                <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                                <br />
                                <br />
                                <h5>Attiva il tuo account prima di eseguire il login!</h5>

                                
                                
                                <img src={(require('./../../assets/svg/emailSent.svg'))} className={`img-fluid ${Classes.ImgMail}`} alt="phone" title="phone" />
                                <br/>
                                <p>Accesso veloce?</p>
                                <button className={Classes.CustomLoginButton} type="button"> <a href="https://mail.google.com/mail/u/0/" target="_blank"> <i className="fas fa-envelope-open-text"> </i> Apri Gmail</a></button>
                                <br/>
                                <br/>  
                                <div className={Classes.BlueInfo}>
                                <p><b>I prossimi passi?</b> <br /> - Esegui il login per impostare e configurare il tuo spot! <br/> - Scarica l'app moramma dagli store per interagire con il tuo spot</p>
                                <p>
                                    <span>
                                        <a style={{textDecoration:'none', color:'white', fontSize:'45px'}} href="https://play.google.com/store/apps/details?id=wagooitalia.wagoomusic&hl=it"><i  style={{color:'white !important'}} class="fa-icons fab fa-android animated fadeIn"></i>
                                        </a> <a style={{textDecoration:'none', color:'white', fontSize:'45px'}} href="https://itunes.apple.com/it/app/moramma/id1382717294?mt=8"><i class="fa-icons fab fa-apple animated fadeIn"></i></a></span></p>
                                     </div>
                            </div>
                            <br/>
                        </div>
                        <div className="col" />
                        </div>
                    </div>
                    <ReactTooltip />
                    <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
                </Aux>
            )
        }
        
        return (
            <Aux>
            { !this.state.next ? (
            <Aux>
                <div className="container-fluid">
                    <br />
                    <br />
                    <div className="row">
                    <div className="col" />
                    <div className={`col-5 ${Classes.TxtCenter}`}>
                        <div className={` ${Classes.CardLogin}`}>
                            <br />
                            <br />
                            <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                            <br />
                            <br />
                            <h4 className={`${Classes.Cardtitle} animated fadeIn`}>{lang[this.state.language].registerscreen_about_you}</h4>
                            <br />
                            <p className="animated fadeIn">{lang[this.state.language].registerscreen_about_you_description}.</p>
                            <br/>
                                <TextField
                                    error={this.state.txtNameError}
                                    helperText={this.state.txtNameError ? 'Must be > 3 and cannot contian spaces' : ''}
                                    label={lang[this.state.language].registerscreen_txt_name}
                                    type="text"
                                    name="name"
                                    margin="normal"
                                    variant="outlined"
                                    value={this.state.txtName}
                                    onChange={this.onChangeTxtName}
                                    className={Classes.Inputbox}
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <TextField
                                    error={this.state.txtSurnameError}
                                    helperText={this.state.txtSurnameError ? 'Must be > 3 and cannot contian spaces' : ''}
                                    label={lang[this.state.language].registerscreen_txt_surname}
                                    type="text"
                                    name="lastname"
                                    margin="normal"
                                    variant="outlined"
                                    value={this.state.txtSurname}
                                    onChange={this.onChangeTxtSurname}
                                />
                                <br/>
                                <TextField
                                    error={this.state.txtEmailFormatError}
                                    helperText={this.state.txtEmailFormatError ? 'Invalid email' : ''}
                                    label={lang[this.state.language].registerscreen_txt_email}
                                    type="email"
                                    name="Email"
                                    autoComplete="autocompl"
                                    margin="normal"
                                    variant="outlined"
                                    value={this.state.txtEmail}
                                    onChange={this.onChangeTxtEmail}
                                />
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <TextField
                                    error={this.state.txtEmailError}
                                    helperText={this.state.txtEmailError ? 'Email must be equals!' : ''}
                                    label={lang[this.state.language].registerscreen_txt_confirm_email}
                                    type="email"
                                    name="ConfirmEmail"
                                    autoComplete="autocompl"
                                    margin="normal"
                                    variant="outlined"
                                    value={this.state.txtEmailConfirm}
                                    onChange={this.onChangeTxtEmailConfirm}
                                />
                                <br/>
                                <br/>
                                <br/>
                                <div className={`col-12 ${Classes.Privacy}`}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={this.state.chbxPersonalInfo}
                                        onChange={this.onChangeChbxPersonalInfo}
                                        value="checkedB"
                                        color="primary"
                                    />
                                    }
                                    className={Classes.Privacy}
                                    label={lang[this.state.language].registerscreen_cbox_privacy}
                                />
                                </div>
                                <br/>
                            <button className={Classes.LoginButton} onClick={this.nextButton} type="button"> {lang[this.state.language].registerscreen_btn_next} </button>
                            <br/>
                            <br/>
                        </div>
                        <br/>
                        <p> <a className={Classes.Link}  target="_blank" href="https://moramma.com/it-privacy-policy.html">Privacy</a> | <i onClick={this.changeLanguage} data-html="true" data-place="right" data-tip="Change language <br /> Cambia lingua" className={`fas fa-flag ${Classes.HelpIcon}`} /></p>
                    </div>
                    <div className="col" />
                    <div className={`col-6 ${Classes.TxtCenter} d-flex flex-column align-self-center justify-content-center`}>
                            <h2 className={`animated fadeInUp ${Classes.RightDescription}`}>{lang[this.state.language].registerscreen_slogan_1of2}<br />{lang[this.state.language].registerscreen_slogan_2of2}</h2>
                            <br/>
                            <img lassName="animated fadeInUp img-fluid" src={require('./../../assets/img/pc-twice.png')} style={{maxWidth: 600}} />
                            <br/>
                            <p className={`animated fadeInUp ${Classes.ToRight}`}>{lang[this.state.language].registerscreen_slogan_descr}</p>
                    </div>
                    <div className="col" />
                    </div>
                </div>
                <ReactTooltip />
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
            </Aux>
        ) : (
            <Aux>
                <div className="container-fluid">
                    <br />
                    <br />
                    <div className="row">
                    <div className="col" />
                    <div className={`col-5 ${Classes.TxtCenter}`}>
                        <div className={` ${Classes.CardLogin}`}>
                            <br />
                            <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                            <br />
                            <h4 className="animated fadeIn">{lang[this.state.language].loginscreen_about_spot}</h4>
                            <br />
                            <p><i>{lang[this.state.language].loginscreen_about_spot_descr_long}.</i></p>

                            <p className={Classes.RedWarning}><u>{lang[this.state.language].loginscreen_about_spot_map_attention}</u>:{lang[this.state.language].loginscreen_about_spot_map_hint}.</p>
                            <div className="col-12">
                                <Map link={this.link}
                                mylat={this.state.mylat}
                                mylng={this.state.mylng}>
                                </Map>
                            </div>
                            <br/>
                            <br/>
                            <p>{lang[this.state.language].loginscreen_about_spot_map_info}</p>
                        <div className={`col-12 ${Classes.DivInformation}`}>
                            <p>{this.state.txtaddress}</p>
                            <p className={Classes.Txtlatlng}>{this.state.txtLat} / {this.state.txtLng}</p>
                        </div>
                        <br />
                        <br />
                        
                        </div>
                        <br/>
                        <p> <a className={Classes.Link}  target="_blank" href="https://moramma.com/it-privacy-policy.html">Privacy</a> | <i onClick={this.changeLanguage} data-html="true" data-place="right" data-tip="Change language <br /> Cambia lingua" className={`fas fa-flag ${Classes.HelpIcon}`} /></p>
                    </div>
                    <div className="col" />
                    <div className={`col-5`}>
                        <div className={` ${Classes.CardLogin}`}> 
                        <br />
                        <p className={Classes.RedWarning}>{lang[this.state.language].loginscreen_about_spot_app_infoWarning}!</p>
                        <div className="row col-12">
                        <div className="col-6">
                        <i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_about_spot_txt_name_hint} className={`fas fa-question-circle ${Classes.Inline} ${Classes.HelpIcon} ${Classes.TxtLeft}`} />           
            
                        <TextField
                            error={this.state.txtLocationNameError}
                            helperText={this.state.txtLocationNameError ? 'Must be > 3, no special characters' : ''}
                            label={lang[this.state.language].loginscreen_about_spot_txt_name}
                            type="text"
                            name="LocationName"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            onChange={this.onChangeTxtLocationName}
                        />

                <ReactTooltip />
                        </div>
                        <div className="col-6">
                        
                        <i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_about_spot_txt_slogan_hint} className={`fas fa-question-circle ${Classes.Inline} ${Classes.HelpIcon} ${Classes.TxtLeft}`} />           
                        <TextField
                            error={this.state.txtLocationSloganErr}
                            helperText={this.state.txtLocationSloganErr ? 'Must be > 3, no special characters' : ''}
                            label={lang[this.state.language].loginscreen_about_spot_txt_slogan}
                            type="text"
                            name="Slogan"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            onChange={this.onChangeTxtLocationSlogan}
                        />

                <ReactTooltip />
                        </div>
                       
                        </div>
                        <div className="row col-12">
                        <div className="col-12">
                        <i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_about_spot_txt_url_hint} className={`fas fa-question-circle ${Classes.Inline} ${Classes.HelpIcon} ${Classes.TxtLeft}`} />           
                     
                       <TextField
                           label={lang[this.state.language].loginscreen_about_spot_txt_url}
                           helperText={this.state.txtImageError ? 'Please enter valid url!' : ''}
                           type="text"
                           name="UrlBarImage"
                           autoComplete="autocompl"
                           margin="normal"
                           variant="outlined"
                           fullWidth
                           onChange={this.onChangeUrlImg}
                       />

                <ReactTooltip />
                       </div>
                      
                        </div>
                    
                       
                        <br/>
                        <br/>
                        <div className="row col-12">
                            <div className="col-12">
                            <p className={Classes.Inline}><i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_about_spot_area_hint} className={`fas fa-question-circle ${Classes.Inline} ${Classes.HelpIcon} ${Classes.TxtLeft}`} /> &nbsp;          
                            {lang[this.state.language].registerscreen_sel_area} </p>
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectArea}
                                onChange={this.onAreaSelectChanges}
                                >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={75}>75</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={125}>125</MenuItem>
                                <MenuItem value={150}>150</MenuItem>
                                <MenuItem value={175}>175</MenuItem>
                                <MenuItem value={200}>200</MenuItem>
                                <MenuItem value={250}>250</MenuItem>
                                <MenuItem value={350}>350</MenuItem>
                                <MenuItem value={450}>450</MenuItem>
                                <MenuItem value={0}>Nessun limite</MenuItem>
                            </Select>

                <ReactTooltip />
                            </div>
                        </div>
                        <br/>

                        <div className="row col-12">
                            <div className="col-12">
                            <p className={Classes.Inline}><i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_about_spot_floor_hint} className={`fas fa-question-circle ${Classes.Inline} ${Classes.HelpIcon} ${Classes.TxtLeft}`} /> &nbsp;          
                            {lang[this.state.language].registerscreen_sel_floor} </p>
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectFloorNumber}
                                onChange={this.onFloorNumberChanges}
                                >
                                <MenuItem value={0}>0</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={7}>7</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                            </Select>

                <ReactTooltip />
                            </div>
                        </div>
                        <br/>

                        <div className="row col-12">
                            <div className="col-12">
                            <p className={Classes.Inline}><i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_about_spot_type_hint} className={`fas fa-question-circle ${Classes.Inline} ${Classes.HelpIcon} ${Classes.TxtLeft}`} /> &nbsp;          
                            {lang[this.state.language].registerscreen_sel_radius} </p>
                            <Select
                                labelId="demo-customized-select-label"
                                id="demo-customized-select"
                                value={this.state.selectSpotRadius}
                                onChange={this.onSpotRadiusChanges}
                                >
                                <MenuItem value={'Bar'}>Bar</MenuItem>
                                <MenuItem value={'Palestra'}>Palestra</MenuItem>
                                <MenuItem value={'Pub'}>Pub</MenuItem>
                                <MenuItem value={'Discoteca'}>Discoteca</MenuItem>
                                <MenuItem value={'Università'}>Università</MenuItem>
                                <MenuItem value={'Ristorante'}>Ristorante</MenuItem>
                                <MenuItem value={'Fiera'}>Fiera</MenuItem>
                                <MenuItem value={'Radio'}>Radio</MenuItem>
                                <MenuItem value={'Altro'}>Altro</MenuItem>
                            </Select>

                <ReactTooltip />
                            </div>
                        </div>
                        <br/>
                        <div className="col-12">
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={this.state.chbxLocationInfo}
                                onChange={this.onChangeChbxPlaceInfo}
                                value="checkedB"
                                color="primary"
                            />
                            }
                            label={lang[this.state.language].registerscreen_cbox_privacy}
                        />
                        </div>
                        <div className="col-12">
                        </div>
                        <br/>
                      
                        <br/>
                        <button className={Classes.LoginButton} onClick={this.registerBtn} type="button"> {lang[this.state.language].registerscreen_btn_register} </button>
                            <br/>
                            <br/>
                        </div>
                        <br/>
                      </div>
                    <div className="col" />
                    </div>
                </div>
                <ReactTooltip />
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
            </Aux>
        )
    }
    </Aux>
    );
    }
}

export default RegisterScreen;